import Parse from "parse";
import ParseConfig from "@/api/parse.config";

export async function getSuiviForUser(userId) {
  ParseConfig();
  const result = await Parse.Cloud.run("getSuiviForUser",  { userId: userId });
  console.log("result-get-suivi-for-user", result);
  return result;
}